module.exports = __webpack_public_path__ + "static/img/sub_banner_pic1.1d987b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/home/sub_banner_pic1.png
// module id = /4js
// module chunks = 31